module.exports = __webpack_public_path__ + "static/img/FullLogo.94f409f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alli/FullLogo.png
// module id = 4Fpc
// module chunks = 1